<template>
  <Modal :is-open="isOpen" container-class="rounded-lg" ref="modal" :showCloseButton="false">
    <div class="px-4 py-2">
      <h2 class="text-center text-lg font-bold">Notificacion</h2>
      <VistaGmail :notificacion="notificacion" />
    </div>
    <template #footer>
      <div class="m-2 flex flex-row justify-center space-x-4">
        <button
          class="btn btn-primary inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
          @click="$emit('modal:close')"
        >
          Cerrar
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useComposeModal } from '@colescba/ui'
import VistaGmail from './VistaGmail.vue'

export default {
  name: 'ReenviarNotificacion',
  props: {
    notificacion: { type: Object, required: true, default: null },
  },
  mixins: [useComposeModal()],
  components: { VistaGmail },
}
</script>
